<template>
  <div class="container">
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{
          $t('lbl.userComponent.pageHeader')
        }}</v-toolbar-title>
      </v-col>
    </v-row>

    <v-row class="custom-form-control custom-figma-1">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-figma-1"
            cols="12"
            lg="5"
            md="5"
          >
            <v-row>
              <v-col cols="12" lg="6" md="4" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.uc_name"
                  :label="$t('lbl.common.conditionSearch.findByUserComponentName')"
                  @keyup.enter="searchItem"
                  class="custom-selectbox"
                  height="30"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="masterSearchItems.uc_type"
                  :items="this.codeItem"
                  :label="$t('lbl.common.conditionSearch.selectType')"
                  @change="searchItem"
                  class="custom-selectbox"
                  height="30"
                  hide-details
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" md="4" class="pt-0 pb-0 pr-24px">
                <v-autocomplete
                  v-model="masterSearchItems.lock_yn"
                  :items="this.lockedItems"
                  :label="$t('lbl.common.conditionSearch.selectLocked')"
                  @change="searchItem"
                  class="custom-selectbox"
                  height="30"
                  hide-details
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 mt-0 text-right custom-figma-1"
            cols="12"
            lg="7"
            md="7"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-autocomplete
                v-model="dataType"
                :items="dateTypes"
                :label="$t('lbl.common.conditionSearch.dateType')"
                :menu-props="{ offsetY: true }"
                @change="searchItem"
                class="custom-selectbox"
                hide-details
                dense
                solo
              ></v-autocomplete>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                v-model="fromDate"
                :close-on-content-click="false"
                ref="fromdate_menu"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.fr_date"
                    :disabled="!dateCond"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    :placeholder="' '"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="masterSearchItems.fr_date"
                  :disabled="!dateCond"
                  :max="getMaxDate"
                  @input="
                    fromDate = false;
                    changeDate('from');
                  "
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.fromdate_menu.save(masterSearchItems.fr_date)"
                    >{{ $t('btn.common.ok') }}</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 d-inline-flex">
              <v-menu
                v-model="toDate"
                :close-on-content-click="false"
                ref="todate_menu"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.to_date"
                    :disabled="!dateCond"
                    :placeholder="' '"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="masterSearchItems.to_date"
                  :disabled="!dateCond"
                  :allowed-dates="allowedDates"
                  @input="
                    toDate = false;
                    changeDate('to');
                  "
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="todate_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="$refs.todate_menu.save(masterSearchItems.to_date)"
                    >{{ $t('btn.common.ok') }}</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn
                class="btn btn-top btn-search btn-width-1"
                color="primary"
                @click.native="searchItem"
              >
                <v-icon x-small class="mr-2">fa fa-search</v-icon>{{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn
                  class="btn btn-add"
                  :disabled="!$auth.manage"
                  @click="openUserCompWindow(null, 'Add')"
                >
                  {{ $t('btn.common.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" lg="5" md="5">
                <v-select
                  v-model="searchBy"
                  :items="searchByItems"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  @change="onFilterUserComponent"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                  height="30"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" lg="7" md="7">
                <v-text-field
                  v-model="search"
                  @input="onFilterUserComponent"
                  @click:append="onFilterUserComponent"
                  @keyup.enter="onFilterUserComponent"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  heigth="30"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :hide-default-footer="true"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight"
          @click:row="onClickRow"
          @page-count="pageCount = $event"
          :class="[
            'list-table code-table srm-list-table custom-border-table',
            totalCnt > 0 ? '' : 'custom-border-table-not-data',
          ]"
          no-data-text="No matching records found"
        >
          <template v-slot:item.INDEX="{ item }">
            <div class="index-col">{{ listData.indexOf(item) + 1 }}</div>
          </template>
          <template v-slot:item.uc_type="{ item }" class="text-center">
            <div>{{ item.uc_type == 'R' ? 'COM' : 'CVT' }}</div>
          </template>
          <template v-slot:item.lock_yn="{ item }" class="locked-col">
            <v-icon
              v-if="item.lock_yn === 'y'"
              small
              @click.native="releaseLocked(item)"
              :disabled="!$auth.manage"
              >fas fa-check-square</v-icon
            >
            <v-icon v-if="item.lock_yn === 'n'" small>far fa-window-close</v-icon>
          </template>
          <template v-slot:item.uc_ver="{ item }" class="type-col text-center">
            <div v-if="!$auth.manage">{{ item.uc_ver }}</div>
            <a v-else class="link-file-text" @click="openUserComponentVersion(item)">{{
              item.uc_ver
            }}</a>
          </template>
          <template v-slot:item.manage="{ item }">
            <div class="text-center">
              <v-btn
                small
                text
                icon
                :disabled="!$auth.manage"
                @click="openUserCompWindow(item, 'Modify')"
              >
                <icon-svg :disabled="!$auth.manage" iconName="edit" />
              </v-btn>
              <v-btn small text icon :disabled="!$auth.manage" @click="deleteItem(item)">
                <icon-svg :disabled="!$auth.manage" iconName="delete" />
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                    hide-details
                    dense
                    solo
                  ></v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{ totalCnt - itemsPerPage * page > 0 ? itemsPerPage * page : totalCnt }}
                    of {{ totalCnt }}
                  </v-label>
                </div>
                <button
                  type="button"
                  @click="handlePageChange(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field>
                <label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="handlePageChange(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialogWindow
      ref="confirmDeleteFileDialog"
      size="max"
      :info="deleteDataName"
      title="confirmDialog"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the User Component'])"
      color="confirmation"
      :dataValue="deleteData"
      @select-ok="okDeleteFile($event)"
      :showCancel="true"
    ></dialogWindow>
    <dialogWindow
      ref="warningDialog"
      size="max"
      :detail="
        $t('msg.common.warning.detailWarningReleaseLocked', [
          'user component',
          releasingComp.uc_check_in_user,
          'User Component',
        ])
      "
      color="warning"
    >
    </dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail="$t('msg.common.validateDate')"
      color="validation"
    ></dialogWindow>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <addUserComponent
        v-if="dialog.type == 'addUserComponent'"
        @openLoadFile="openLoadFile($event)"
        class="maplist-layout-dialog add-code-dialog"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        ref="addUserComponent"
      ></addUserComponent>
      <ucVersionHistory
        v-if="dialog.type == 'ucVersionHistory'"
        class="custom-dialog mapper-version"
        @openDeployUserComp="openDeployUserComp($event)"
        @viewFileMoveUserCompSim="viewFileMoveUserCompSim($event)"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :id="dialog.id"
        @refreshUcList="searchItem()"
      ></ucVersionHistory>
      <versionHistory
        v-if="dialog.type == 'versionHistory'"
        class="custom-dialog mapper-version"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :id="dialog.id"
        title="UserComponent"
      ></versionHistory>
      <load-file-dialog
        v-if="dialog.type == 'loadFile'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :prs="prs"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @fileChanged="fileChanged($event)"
        class="load-file-dialog"
      >
      </load-file-dialog>
      <deployUserComp
        v-if="dialog.type == 'deployUserComp'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @openLoadFile="openLoadFile($event)"
        class="custom-dialog mapper-version"
        ref="deployUserComp"
      >
      </deployUserComp>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { mapState } from 'vuex';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import addUserComponent from '@/vue-caas/views/usercomp/AddUserComponent.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import ucVersionHistory from '@/vue-caas/views/usercomp/UserComponentVersionHistory.vue';
import loadFileDialog from '@/vue-caas/views/usercomp/LoadFile.vue';
import deployUserComp from '@/vue-caas/views/usercomp/DeployUserComp.vue';
import versionHistory from '@/vue-caas/components/DelHistoryWorkflowDialog.vue';
import cfg from '@/vue-caas/config/config.js';
import { openWindow } from '@/vue-dlb/utils/window-opener';

export default {
  components: {
    SystemProgress,
    IconSvg,
    addUserComponent,
    dialogWindow,
    versionHistory,
    loadFileDialog,
    deployUserComp,
    ucVersionHistory,
  },
  computed: {
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
    getMaxDate() {
      return getAppliedTimeZone();
    },
    getMinDate() {
      return this.masterSearchItems.fr_date;
    },
  },
  data() {
    return {
      tableHeight: 827,
      fromdate_menu: false,
      fromdate: null,
      todate_menu: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      pageEnter: 1,
      search: '',
      releasingComp: {},
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
      lockedItems: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'Y', value: 'Y' },
        { text: 'N', value: 'N' },
      ],
      headers: [
        { text: this.$t('tbl.common.columnNo'), value: 'INDEX', width: '60px', align: 'center' },
        { text: 'User Component Name', value: 'uc_name', width: '220px', align: 'center' },
        { text: 'Script File', value: 'uc_file_name', width: '220px', align: 'center' },
        { text: 'Type', value: 'uc_type', width: '170px', align: 'center' },
        { text: 'Locked', value: 'lock_yn', width: '170px', align: 'center' },
        { text: 'Version', value: 'uc_ver', width: '170px', align: 'center' },
        {
          text: 'Manage',
          value: 'manage',
          width: '170px',
        },
        {
          text: 'Update User',
          value: 'upd_user',
          align: 'center',
        },
        {
          text: 'Update Date',
          value: 'upd_dt',
          align: 'center',
        },
      ],
      dataType: false,
      fromDate: false,
      fromTime: false,
      fromTimeData: '00:00',
      toDate: false,
      toTimeData: '23:59:59',
      toTime: false,
      dateCond: true,
      masterSearchItems: {
        uc_name: '',
        uc_type: '',
        lock_yn: '',
        fr_date: getAppliedTimeZone(),
        to_date: getAppliedTimeZone(),
      },
      codeItem: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'As Connector', value: 'R' },
        { text: 'As Converter', value: 'C' },
      ],
      selectMasterRows: [],
      searchBy: 'all',
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'User Component Name', value: 'uc_name' },
        { text: 'User Component Script Name', value: 'uc_file_comment' },
        { text: 'Type', value: 'uc_type' },
        { text: 'Udate User', value: 'upd_user' },
      ],
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      selected: null,
      dateTypes: [
        { value: false, text: 'Search by' },
        { value: true, text: 'Update Date' },
      ],
      isLoading: false,
      totalCnt: 0,
      listData: [],
      deleteDataName: '',
      deleteData: '',
      selectedRow: '',
    };
  },
  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false; // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0, 10) === dateString;
    },
    formatDate(side, evt) {
      let dateString =
        side === 'from' ? this.masterSearchItems.fr_date : this.masterSearchItems.to_date;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if (
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 4 &&
          !dateString.includes('-')) ||
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 7 &&
          dateString[4] === '-' &&
          (dateString.match(/-/g) || []).length == 1)
      ) {
        dateString += '-';
        side === 'from'
          ? (this.masterSearchItems.fr_date = dateString)
          : (this.masterSearchItems.to_date = dateString);
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if (!this.validateDateInput(this.masterSearchItems.fr_date)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.fr_date = getAppliedTimeZone();
          this.masterSearchItems.to_date = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.fr_date > getAppliedTimeZone()) {
          this.masterSearchItems.fr_date = getAppliedTimeZone();
        }
        if (this.masterSearchItems.fr_date > this.masterSearchItems.to_date) {
          this.masterSearchItems.to_date = this.masterSearchItems.fr_date;
        }
      }
      if (side === 'to') {
        if (!this.validateDateInput(this.masterSearchItems.to_date)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.to_date = getAppliedTimeZone();
          this.masterSearchItems.fr_date = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.to_date > getAppliedTimeZone()) {
          this.masterSearchItems.to_date = getAppliedTimeZone();
        }
        if (this.masterSearchItems.fr_date > this.masterSearchItems.to_date) {
          this.masterSearchItems.fr_date = this.masterSearchItems.to_date;
        }
      }
    },
    viewFileMoveUserCompSim(item) {
      const type = 'userCompSim';
      const url = '/component/usercomp/usersimulator';
      const params = {
        ROWID: item.uc_id,
        type: type,
        options: {
          dataValue: item,
          id: item.uc_id,
        },
      };
      item.id = item.uc_id + item.uc_ver;
      const arrView = {
        item,
        type,
      };
      const querystring = `&userCompId=${item.uc_id}&ver=${item.uc_ver}`;
      openWindow({
        arrView,
        url: url,
        params,
        queryParams: querystring,
      });
    },
    openDeployUserComp(itemRow) {
      let type = 'deployUserComp';
      let item = {
        ROWID: 0,
        action: 'usercompsim',
        data: itemRow,
      };
      let indexArrDialog = this.findDialog('deployUserComp_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    fileChanged(item) {
      if (this.findDialog('addUserComponent_0') != null) {
        this.$refs.addUserComponent[0].onFileChanged(item);
      }
      if (this.findDialog('deployUserComp_0') != null) {
        this.$refs.deployUserComp[0].onFileChanged(item);
      }
    },
    openLoadFile(data) {
      this.prs = {
        CUST_ID: 'cyberlogitec.com',
        STR_SNDR: 'NDAL',
        STR_RCVR: 'CTCT',
        MSG_ID: 'COPARN',
        MSG_VER: 'UND95B',
        DAT_TYPE: 'UPDT',
        FR_DAT: '20200615',
        TO_DAT: '20200715',
        MSG_CNT: null,
        FFL_FILE_NAME: null,
        MAP_NAME: 'test_add_file_modify',
        MAP_CONV_TP: 'F2E',
        FFL_FRMT_TP: null,
        PRCS_STS: 'REPO',
        LAY_PRCS_NO: 'R000000152',
        SRM_PRCS_NO: 'REP0000085',
        ALIAS: '',
        ROWID: 29,
      };
      let type = 'loadFile';
      let item = {
        ROWID: 0,
        data,
      };
      let indexArrDialog = this.findDialog('loadFile_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    changeDtTp() {
      const params = {
        uc_name: this.masterSearchItems.uc_name,
        uc_type: this.masterSearchItems.uc_type,
        lock_yn: this.masterSearchItems.lock_yn,
      };
      if (this.dataType) {
        params.fr_date = this.masterSearchItems.fr_date + ' ' + this.fromTimeData;
        params.to_date = this.masterSearchItems.to_date + ' ' + this.toTimeData;
        this.masterSearchItems.fr_date = this.masterSearchItems.fr_date || getAppliedTimeZone();
        this.masterSearchItems.to_date = this.masterSearchItems.to_date || getAppliedTimeZone();
        this.dateCond = true;
      } else {
        this.masterSearchItems.fr_date = '';
        this.masterSearchItems.to_date = '';
        this.dateCond = false;
      }
      return params;
    },
    searchItem() {
      this.isLoading = true;
      const params = this.changeDtTp();
      this.$store
        .dispatch('getUserComponentList', params)
        .then((res) => {
          this.listData = this.$store.getters.userComponentList;
          this.isLoading = false;
          this.totalCnt = this.listData.length;
          this.caculatePageCount();
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
    caculatePageCount() {
      if (this.totalCnt % this.itemsPerPage === 0) {
        this.pageCount = this.totalCnt / this.itemsPerPage;
      } else {
        this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
      }
    },
    allowedDates(val) {
      let date = getAppliedTimeZone();
      if (val <= date) {
        return val;
      }
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    handlePageChange(value) {
      this.page = value;
    },
    openUserCompWindow(itemRow, typeActive) {
      let type = 'addUserComponent';
      let item = {
        ROWID: 0,
        action: typeActive,
        data: itemRow,
      };
      let indexArrDialog = this.findDialog('addUserComponent_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openUserComponentVersion(itemRow) {
      let type = 'ucVersionHistory';
      let item = {
        ROWID: 0,
        data: itemRow,
      };
      let indexArrDialog = this.findDialog('ucVersionHistory_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    openVersionHistory(list, val) {
      let type = 'versionHistory';
      let item = {};
      item.ROWID = 0;
      item.versionList = list;
      item.comNm = val.uc_name;
      item.item = this.deleteData;
      let indexArrDialog = this.findDialog('versionHistory_0');
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    deleteItem(item) {
      this.deleteData = item.uc_id;
      this.deleteDataName = item.uc_name;
      let self = this;
      if (cfg.isDlb) {
        self.$refs.confirmDeleteFileDialog.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', { type: 'UC', value: item.uc_id })
          .then((res) => {
            if (res.length > 0) {
              self.openVersionHistory(res, item);
            } else {
              self.$refs.confirmDeleteFileDialog.dialog = true;
            }
          });
      }
    },
    okDeleteFile(item) {
      this.$store.dispatch('deleteUserComponent', { uc_id: item }).then((res) => {
        this.searchItem();
      });
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    onClickRow(item) {
      this.selectedRow = item.uc_id;
    },
    toggleLocked(item) {
      this.$store
        .dispatch('toggleLocked', { uc_id: item.uc_id, lock_yn: item.lock_yn })
        .then((res) => {
          this.searchItem();
        });
    },
    releaseLocked(item) {
      this.releasingComp = item;
      if (item.uc_check_in_user == this.$cookies.get('user-id')) {
        Store.dispatch('toggleLocked', { uc_id: item.uc_id }).then(() => {
          this.searchItem();
        });
      } else this.$refs.warningDialog.dialog = true;
    },
    onFilterUserComponent(str) {
      setTimeout(() => {
        this.$store
          .dispatch('setFilterUserComponent', { filter: this.searchBy, str: this.search })
          .then(() => {
            this.listData = this.$store.getters.userComponentList;
            this.totalCnt = this.listData.length;
            this.caculatePageCount();
          });
      }, 300);
    },
  },
  created() {
    this.searchItem();
    EventBus.$on('refeshListUserComponent', this.searchItem);
    EventBus.$on('delete-item', this.okDeleteFile);
  },
  mounted() {
    window.addEventListener('storage', (event) => {
      if (event.key === 'processSharedData') {
        const updatedState = JSON.parse(event.newValue);
        if (updatedState?.USR) {
          this.searchItem();
        }
      }
    });
  },
};
</script>
